<script>
import { BButton, BCard, BCardHeader, BCardTitle, BCardBody } from 'bootstrap-vue';
import CreateItemModal from '../../items/CreateItemModal.vue';
import useInvoiceDetails from './useInvoiceDetails.js';

export default {
  name: 'InvoiceFormDetails',
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    CreateItemModal,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    furtherTaxPercent: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  setup(props, { emit }) {
    return useInvoiceDetails(props, { emit });
  },
};
</script>

<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Invoice Details</b-card-title>
      <div>
        <b-button size="sm" variant="primary" @click="showCreateItemModal = true" class="mr-1">
          <i class="fas fa-plus"></i>
          Create New Item Row
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="addNewRow" class="mr-1">
          <i class="fas fa-plus"></i>
          Add Row
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="toggleAddTaxCol">
          <i :class="showAddTaxCol ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          {{ showAddTaxCol ? 'Hide Add Tax' : 'Show Add Tax' }}
        </b-button>
      </div>
    </b-card-header>

    <b-card-body class="px-0">
      <div ref="tableRef" class="fbr-invoice-handsontable-container"></div>
    </b-card-body>

    <create-item-modal
      :show.sync="showCreateItemModal"
      @submit="onItemCreated"
      @hidden="showCreateItemModal = false"
    />
  </b-card>
</template>

<style lang="scss">
.fbr-invoice-handsontable-container {
  .ht_master.handsontable {
    .wtHolder {
      padding-bottom: 2rem !important;
    }
  }

  // Make headers taller to accommodate totals
  .htCore thead {
    height: 60px !important;
  }

  // Ensure proper alignment for header content
  .htCore thead th {
    text-align: center !important;
    // vertical-align: middle !important;
    line-height: 1.2 !important;
    padding: 8px 4px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    min-height: 50px !important;
  }

  .column-header-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }

  .column-title {
    font-weight: bold !important;
    font-size: 13px !important;
    height: 100% !important;
  }

  .htCore thead th > div .column-header-total {
    font-size: 15px !important;
    color: #6c757d !important;
    font-weight: bold !important;
    margin-top: 2px !important;
    border-top: 1px solid #dee2e6 !important;
    padding-top: 2px !important;
    width: 100% !important;
    text-align: end !important;
  }
}
</style>
